import { render } from "./KoruSplitButton.vue?vue&type=template&id=8ac77a4e&scoped=true"
import script from "./KoruSplitButton.vue?vue&type=script&lang=js"
export * from "./KoruSplitButton.vue?vue&type=script&lang=js"

import "./KoruSplitButton.vue?vue&type=style&index=0&id=8ac77a4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac77a4e"]])

export default __exports__